import { render, staticRenderFns } from "./TransactionFee.vue?vue&type=template&id=5e525461&"
import script from "./TransactionFee.vue?vue&type=script&lang=js&"
export * from "./TransactionFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports